export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const WOOT_PREFIX = 'chatwoot-widget:';

export const SUMO_PREFIX = 'sumo-console:';
export const SUMO_INIT_EVENT = 'accountInitialized';
export const SUMO_OPEN_CHAT_EVENT = 'openAccountConversation';
export const SUMO_CHECK_IS_VIDEO_SERVICE_INTEGRATED = 'checkIsVideoServiceIntegrated';
export const SUMO_BOT_TYPING_MESSAGE = 'sumo--bot--typing';
export const SUMO_CONCIERGE_SELECT_MESSAGE = 'Select:';
export const SUMO_OPEN_BOOK_MEETING_MODAL_EVENT = 'openBookMeetingModal';
export const SUMO_SEND_BOOKING_LINK_EVENT = 'sendBookingLink';
export const SUMO_INLINE_BOOKING_CONTROL_EVENT = 'inlineBookingControl';
export const SUMO_INLINE_BOOKING_STATUS_EVENT = 'inlineBookingStatus';
